var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:['btn', 'btn-sm', 'btn-icon', _vm.button_type],attrs:{"type":"button","rel":"tooltip"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:['tim-icons', _vm.icon_type]})])}
var staticRenderFns = []

export { render, staticRenderFns }